<rask-header [uppercase]="true">Leveranser</rask-header>
<rask-container-block>
  <ng-container header>Hämta leveranser</ng-container>
  <div class="row">
    <rask-selector label="Källa"
      class="col-2"
      [values]="kallaList"
      [(ngModel)]="query.datakalla"
      [viewFormatter]="datakallaviewFormatter"
      [formatter]="datakallaFormatter">
    </rask-selector>
    <rask-datepicker-interval
      class="g-0 col-10"
      labelStartDate="Startdatum"
      labelEndDate="Slutdatum"
      startDate="{{query.periodFrom}}"
      endDate="{{query.periodTom}}"
      (startDate)="setStart($event)"
      (endDate)="setSlut($event)">
    </rask-datepicker-interval>
  </div>
  <div class="row">
    <rask-input class="col-2" label="Leveransnummer" [(ngModel)]="query.leveransnummer"></rask-input>
    <rask-input class="col-2" label="AO-Beteckning/Avtalsobj." [(ngModel)]="query.fritext"></rask-input>
    <rask-selector class="col-3"
      aid="mottagningsplats"
      label="Mottagningsplats"
      [(ngModel)]="query.mottagningsplatsId"
      [minCharacters]="3"
      [debounceTime]="300"
      [viewFormatter]="mottagningsplatsViewFormatter"
      [formatter]="mottagningsplatsSelectedFormatter"
      placeholder="Ange minst tre tecken"
      [search]="searchForMottagningsplatsTypeAhead">
    </rask-selector>
  </div>
  <ng-container footer>
    <rask-button color="secondary" (click)="fetchLeveranser()">Hämta leveranser</rask-button>
    <rask-button color="secondary" negative (click)="rerunLeveranser()">Kör om leveransnr/datum</rask-button>
    <rask-button color="secondary" (click)="omsandningLeveransaggregat()">Omsändning</rask-button>
    <rask-button color="secondary" (click)="exportJsonFromLeverans()">Exportera json</rask-button>
  </ng-container>
</rask-container-block>

<rask-list #leveranserList [data]="leveranser" [useClientFilter]="true" clientFilterResultText="Leveranser"
  [rowSelectable]="true" (checkedChanged)="onCheckedChange()">
  <rask-list-column header="Leveransnummer" field="leveransnummer">
    <ng-template let-row="row">
      {{row.leveransnummer}}<a href="javascript: void(0)" (click)="download(row.leveransnummer)" class="p-l-half">
      <i class="far fa-sm fa-download"></i></a>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Datum" field="datum">
    <ng-template let-row="row">
      <pre>{{row.datum}}</pre>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Beteckning" field="beteckning"></rask-list-column>
  <rask-list-column header="Avtalsobjekt" field="avtalsobjekt"></rask-list-column>
  <rask-list-column header="Koder" field="koder">
    <ng-template let-row="row">
      <pre>{{row.koder}}</pre>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Kontrakt" field="kontrakt">
    <ng-template let-row="row">
      <pre>{{row.kontrakt}}</pre>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="[Inm/Prod] Kval-Msl-Kvant-Avdr" field="kvantitet">
    <ng-template let-row="row">
      <pre>{{row.kvantitet}}</pre>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Kund-/levorder" field="ordrar">
    <ng-template let-row="row">
      <pre>{{row.ordrar}}</pre>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Fardigmatt" field="allaMatningstjansterKorda">
    <ng-template let-value>
      @if (value) {
        <i class="far fa-check"></i>
      }
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Korr." field="harKorrektioner">
    <ng-template let-value>
      @if (value) {
        <i class="far fa-check"></i>
      }
    </ng-template>
  </rask-list-column>
</rask-list>